function toVal(mix) {
    let k;
    let y;
    let str = '';
    if (typeof mix === 'string' || typeof mix === 'number') {
        str += mix;
    }
    else if (typeof mix === 'object') {
        if (Array.isArray(mix)) {
            for (k = 0; k < mix.length; k++) {
                if (mix[k]) {
                    y = toVal(mix[k]);
                    if (y) {
                        str && (str += ' ');
                        str += y;
                    }
                }
            }
        }
        else {
            for (k in mix) {
                if (mix[k]) {
                    str && (str += ' ');
                    str += k;
                }
            }
        }
    }
    return str;
}
export const clsx = (...rest) => {
    let i = 0;
    let tmp;
    let x;
    let str = '';
    while (i < rest.length) {
        tmp = rest[i++];
        if (tmp) {
            x = toVal(tmp);
            if (x) {
                str && (str += ' ');
                str += x;
            }
        }
    }
    return str;
};
export const dispatchForCode = function (event, callback) {
    var code;
    if (event.key !== undefined) {
        code = event.key;
    }
    else if (event.keyIdentifier !== undefined) {
        code = event.keyIdentifier;
    }
    else if (event.keyCode !== undefined) {
        code = event.keyCode;
    }
    callback(code);
};
export function ClickOutside(node, _options = {}) {
    const options = Object.assign({ include: [] }, _options);
    function detect({ target }) {
        if (!node.contains(target) ||
            options.include.some((i) => target.isSameNode(i))) {
            node.dispatchEvent(new CustomEvent('clickOutside'));
        }
    }
    document.addEventListener('click', detect, {
        passive: true,
        capture: true
    });
    return {
        destroy() {
            document.removeEventListener('click', detect);
        }
    };
}
